const CREATE_PROJECT = "CREATE_PROJECT";
const CREATE_PROJECT_SUCCESS = "CREATE_PROJECT_SUCCESS";
const CREATE_PROJECT_ERROR = "CREATE_PROJECT_ERROR";
const UPDATE_PROJECT = "UPDATE_PROJECT";
const UPDATE_PROJECT_SUCCESS = "UPDATE_PROJECT_SUCCESS";
const UPDATE_PROJECT_ERROR = "UPDATE_PROJECT_ERROR";
const FETCH_PROJECT = "FETCH_PROJECT";
const FETCH_PROJECT_SUCCESS = "FETCH_PROJECT_SUCCESS";
const FETCH_PROJECT_ERROR = "FETCH_PROJECT_ERROR";
const PROJECT_DETAILS_IS_EDIT = "PROJECT_DETAILS_IS_EDIT";
const ADD_USER_IN_MANAGER = "ADD_USER_IN_MANAGER";
const FETCH_PROJECTS_UTIL_DATA = "FETCH_PROJECTS_UTIL_DATA";
const FETCH_PROJECTS_UTIL_DATA_SUCCESS = "FETCH_PROJECTS_UTIL_DATA_SUCCESS";
const FETCH_ALL_PROJECTS = "FETCH_ALL_PROJECTS";
const FETCH_ALL_PROJECTS_SUCCESS = "FETCH_ALL_PROJECTS_SUCCESS";
const  FETCH_ALL_PROJECTS_ERROR = " FETCH_ALL_PROJECTS_ERROR"
const DELETE_PROJECT = "DELETE_PROJECT";
const DELETE_PROJECT_SUCCESS = "DELETE_PROJECT_SUCCESS";
const DELETE_PROJECT_ERROR = "DELETE_PROJECT_ERROR";
const DELETE_PROJECT_ATTACH = "DELETE_PROJECT_ATTACH";
const DELETE_PROJECT_ATTACH_SUCCESS = "DELETE_PROJECT_ATTACH_SUCCESS";
const DELETE_PROJECT_ATTACH_ERROR = "DELETE_PROJECT_ATTACH_ERROR";
const PROJECT_DETAIL_CLEANUP_FUNC = "PROJECT_DETAIL_CLEANUP_FUNC";
const PROJECT_NOTIF_IS_EDIT = "PROJECT_NOTIF_IS_EDIT";
const UPDATE_PROJECT_NOTIFICATION = "UPDATE_PROJECT_NOTIFICATION";
const UPDATE_PROJECT_NOTIFICATION_SUCCESS =
  "UPDATE_PROJECT_NOTIFICATION_SUCCESS";
const UPDATE_PROJECT_NOTIFICATION_ERROR = "UPDATE_PROJECT_NOTIFICATION_ERROR";

// Project Weights constants
const PROJECT_WEIGHTS_IS_EDIT = "PROJECT_WEIGHTS_IS_EDIT";
const UPDATE_PROJECT_WEIGHTS = "UPDATE_PROJECT_WEIGHTS";
const UPDATE_PROJECT_WEIGHTS_SUCCESS = "UPDATE_PROJECT_WEIGHTS_SUCCESS";
const UPDATE_PROJECT_WEIGHTS_ERROR = "UPDATE_PROJECT_WEIGHTS_ERROR";

// Project Priorities constants
const PROJECT_PRIORITIES_IS_EDIT = "PROJECT_PRIORITIES_IS_EDIT";
const UPDATE_PROJECT_PRIORITIES = "UPDATE_PROJECT_PRIORITIES";
const UPDATE_PROJECT_PRIORITIES_SUCCESS = "UPDATE_PROJECT_PRIORITIES_SUCCESS";
const UPDATE_PROJECT_PRIORITIES_ERROR = "UPDATE_PROJECT_PRIORITIES_ERROR";

// Project Priority API constants
const FETCH_PROJECT_PRIORITIES = "FETCH_PROJECT_PRIORITIES";
const FETCH_PROJECT_PRIORITIES_SUCCESS = "FETCH_PROJECT_PRIORITIES_SUCCESS";
const FETCH_PROJECT_PRIORITIES_ERROR = "FETCH_PROJECT_PRIORITIES_ERROR";
const CREATE_PROJECT_PRIORITY = "CREATE_PROJECT_PRIORITY";
const CREATE_PROJECT_PRIORITY_SUCCESS = "CREATE_PROJECT_PRIORITY_SUCCESS";
const CREATE_PROJECT_PRIORITY_ERROR = "CREATE_PROJECT_PRIORITY_ERROR";
const UPDATE_PROJECT_PRIORITY = "UPDATE_PROJECT_PRIORITY";
const UPDATE_PROJECT_PRIORITY_SUCCESS = "UPDATE_PROJECT_PRIORITY_SUCCESS";
const UPDATE_PROJECT_PRIORITY_ERROR = "UPDATE_PROJECT_PRIORITY_ERROR";
const DELETE_PROJECT_PRIORITY = "DELETE_PROJECT_PRIORITY";
const DELETE_PROJECT_PRIORITY_SUCCESS = "DELETE_PROJECT_PRIORITY_SUCCESS";
const DELETE_PROJECT_PRIORITY_ERROR = "DELETE_PROJECT_PRIORITY_ERROR";
const SORT_PROJECT_PRIORITIES = "SORT_PROJECT_PRIORITIES";
const SORT_PROJECT_PRIORITIES_SUCCESS = "SORT_PROJECT_PRIORITIES_SUCCESS";
const SORT_PROJECT_PRIORITIES_ERROR = "SORT_PROJECT_PRIORITIES_ERROR";


export {
  CREATE_PROJECT,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_ERROR,
  UPDATE_PROJECT,
  UPDATE_PROJECT_SUCCESS,
  UPDATE_PROJECT_ERROR,
  FETCH_PROJECT,
  FETCH_PROJECT_SUCCESS,
  FETCH_PROJECT_ERROR,
  ADD_USER_IN_MANAGER,
  PROJECT_DETAILS_IS_EDIT,
  FETCH_PROJECTS_UTIL_DATA,
  FETCH_PROJECTS_UTIL_DATA_SUCCESS,
  FETCH_ALL_PROJECTS,
  FETCH_ALL_PROJECTS_SUCCESS,
  FETCH_ALL_PROJECTS_ERROR,
  DELETE_PROJECT,
  DELETE_PROJECT_SUCCESS,
  DELETE_PROJECT_ERROR,
  DELETE_PROJECT_ATTACH,
  DELETE_PROJECT_ATTACH_SUCCESS,
  DELETE_PROJECT_ATTACH_ERROR,
  PROJECT_DETAIL_CLEANUP_FUNC,
  PROJECT_NOTIF_IS_EDIT,
  UPDATE_PROJECT_NOTIFICATION,
  UPDATE_PROJECT_NOTIFICATION_SUCCESS,
  UPDATE_PROJECT_NOTIFICATION_ERROR,
  
  // Project Weights exports
  PROJECT_WEIGHTS_IS_EDIT,
  UPDATE_PROJECT_WEIGHTS,
  UPDATE_PROJECT_WEIGHTS_SUCCESS,
  UPDATE_PROJECT_WEIGHTS_ERROR,
  
  // Project Priorities exports
  PROJECT_PRIORITIES_IS_EDIT,
  UPDATE_PROJECT_PRIORITIES,
  UPDATE_PROJECT_PRIORITIES_SUCCESS,
  UPDATE_PROJECT_PRIORITIES_ERROR,
  
  // Project Priority API exports
  FETCH_PROJECT_PRIORITIES,
  FETCH_PROJECT_PRIORITIES_SUCCESS,
  FETCH_PROJECT_PRIORITIES_ERROR,
  CREATE_PROJECT_PRIORITY,
  CREATE_PROJECT_PRIORITY_SUCCESS,
  CREATE_PROJECT_PRIORITY_ERROR,
  UPDATE_PROJECT_PRIORITY,
  UPDATE_PROJECT_PRIORITY_SUCCESS,
  UPDATE_PROJECT_PRIORITY_ERROR,
  DELETE_PROJECT_PRIORITY,
  DELETE_PROJECT_PRIORITY_SUCCESS,
  DELETE_PROJECT_PRIORITY_ERROR,
  SORT_PROJECT_PRIORITIES,
  SORT_PROJECT_PRIORITIES_SUCCESS,
  SORT_PROJECT_PRIORITIES_ERROR,
};
